import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Banco de 50 Actividades Adicionales de Taller',
  value: '15',
  desc: '50 actividades prácticas listas para usar directamente en el taller, organizadas por tema y nivel de dificultad. Desde ejercicios de observación y registro hasta prácticas completas de elaboración y análisis sensorial.',
  benefit: 'Nunca más llegues al taller sin una actividad práctica que tenga sentido técnico y pedagógico. Ahorrá horas de planificación en cada unidad del año.'
}, {
  id: '02',
  title: 'Banco de Evaluaciones de Tecnología de Alimentos',
  value: '15',
  desc: 'Evaluaciones escritas y prácticas listas con distintos niveles de dificultad y criterios de corrección alineados a cada tomo del pack. Incluye pruebas teóricas, evaluaciones de proceso y rúbricas de taller.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión. Tenés todo listo para cada trimestre del año.'
}, {
  id: '03',
  title: 'Recetario Técnico de Referencia',
  value: '12',
  desc: 'Un recetario técnico completo con las formulaciones más importantes de cada área de procesamiento: conservas, lácteos, cárnicos y fermentados. Cada receta incluye ingredientes con porcentajes exactos, parámetros de control (pH, Brix, temperatura) y puntos críticos de inocuidad.',
  benefit: 'Listo para entregar directamente a tus alumnos o proyectarlo en el taller. Nunca más un alumno elabore un producto sin conocer los parámetros técnicos correctos.'
}, {
  id: '04',
  title: 'Proyectos Productivos Extra',
  value: '10',
  desc: 'Una colección de proyectos productivos adicionales listos para implementar en el taller. Cada proyecto incluye: descripción del producto, formulación técnica, análisis de costos, estrategia de empaque y canal de comercialización sugerido para el mercado latinoamericano.',
  benefit: 'Perfectos para trabajos integradores, ferias escolares, emprendimientos estudiantiles o proyectos de extensión comunitaria. Tus alumnos tienen proyectos reales listos para presentar.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">USD 52,00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}